import { gql } from "@apollo/client";

export const PACKAGE_BILLBOARD = gql`
  query packageBillboard(
    $accessToken: String,
    $page: Int!,
    $size: Int!,
    $sort: String!,
    $startDate: String!,
    $endDate: String!,
    $exposure: String!,
    $packageDate: String!,
    $packageType: String!,
    $publisherId: String!,
    $countryId: String,
    $searchTerm: String
  ) {
    packageBillboard(
      accessToken: $accessToken,
      page: $page,
      size: $size,
      sort: $sort,
      startDate: $startDate,
      endDate: $endDate,
      exposure: $exposure,
      packageDate: $packageDate,
      packageType: $packageType,
      publisherId: $publisherId,
      countryId: $countryId,
      name: $searchTerm
    ) {
      id
      name
      description
      totalPages
      totalPackages
      country {
        id
        name
        timezone
      }
      publisher {
        id
        name
      }
      startDate
      endDate
      validityStartDate
      validityEndDate
      registryPackageType
      campaignDuration
      purchaseLimitation
      numberOfPurchase
      inventory {
        type
        total
        classic
        digital
      }
      exposure
      currency
      price
      discount
      totalPrice
      thumbnail
      publishTo
      tags
      reopened
      createdBy
      createdDate
      lastModifiedBy
      lastModifiedDate
      inventories {
        packageId
        inventoryId
        name
        referenceId
        type
        thumbnail
        location
        screens
        size
        venueType
        group
        latitude
        longitude
        price
        sellingRate
        spotDuration
        displayOnTime
        displayOffTime
        clients
      }
    }
  }
`;

// 🚀 Add Campaign Cart Mutation
export const ADD_CAMPAIGN_CART = gql`
  mutation AddCampaignCart($input: [CampaignCartInput!]!) {
    addCampaignCart(input: $input) {
      itemData {
        success
        message
        statusCode
        id
        sourceId
        dealId
      }
    }
  }
`;

export const ASSIGN_CREATIVES_PACKAGE_INVENTORIES = gql`
  query getAssignCreativesPackageInventories(
    $accessToken: String!
    $packageId: String!
    $page: Int!
    $size: Int!
  ) {
    assaigncreativesPackageInventories(
      accessToken: $accessToken
      packageId: $packageId
      page: $page
      size: $size
    ) {
      packageId
      inventoryId
      name
      referenceId
      type
      thumbnail
      location
      screens
      size
      venueType
      group
      latitude
      longitude
      price
      sellingRate
      spotDuration
      displayOnTime
      displayOffTime
      clients
      estimation {
        potentialViews
        uniqueReach
        avgFrequency
        cpm
        spotsPerHour
        totalSpots
      }
      specification {
        resolution1Width
        resolution1Height
        resolution2Width
        resolution2Height
        resolution3Width
        resolution3Height
        resolution4Width
        resolution4Height
        resolution5Width
        resolution5Height
        resolution6Width
        resolution6Height
      }
      publisher {
        id
        name
      }
      videoSupport
      imageSupport
      audioFormats
    }
  }
`;


export const GET_PACKAGE_DETAILS = gql`
  query getPackageDetails(
    $accessToken: String
    $packageId: String!
    $page: Int!
    $size: Int!
  ) {
    packageDetails(
      accessToken: $accessToken
      packageId: $packageId
      page: $page
      size: $size
    ) {
      id
      name
      description
      country {
        id
        name
        timezone
      }
      publisher {
        id
        name
      }
      startDate
      endDate
      validityStartDate
      validityEndDate
      registryPackageType
      campaignDuration
      purchaseLimitation
      numberOfPurchase
      inventory {
        type
        total
        classic
        digital
      }
      exposure
      currency
      price
      discount
      totalPrice
      thumbnail
      estimation {
        potentialViews
        uniqueReach
        avgFrequency
        cpm
        spotsPerHour
        totalSpots
      }
      inventories {
        packageId
        inventoryId
        name
        referenceId
        type
        thumbnail
        location
        screens
        size
        venueType
        group
        latitude
        longitude
        price
        sellingRate
        spotDuration
        displayOnTime
        displayOffTime
        clients
        estimation {
          potentialViews
          uniqueReach
          avgFrequency
          cpm
          spotsPerHour
          totalSpots
        }
        specification {
          resolution1Width
          resolution1Height
        }
      }
      publishTo
      tagIds
      tags
      reopened
      createdBy
      createdDate
      lastModifiedBy
      lastModifiedDate
    }
  }
`;


export const GET_NOTIFICATIONS = gql`
  query getNotifications(
    $accessToken: String!
    $companyId: String!
    $userId: String!
  ) {
    listNotifications(
      accessToken: $accessToken
      companyId: $companyId
      userId: $userId
    ) {
      id
      notificationMessage
      event
      eventAt
      newMessage
    }
  }
`;

// Below query to read the notifications

export const MARK_NOTIFICATIONS_AS_READ = gql`
  mutation ReadNotification(
    $accessToken: String!
    $notificationIds: [String]!
    $recipientId: String!
  ) {
    readNotification(
      accessToken: $accessToken
      notificationIds: $notificationIds
      recipientId: $recipientId
    ) {
      success
      message
    }
  }
`;

